var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"tooltip"},_vm.events),[_vm._t("default"),_c('span',{ref:"content",staticClass:"tooltip__content",class:{ active: _vm.isActive },style:(_vm.position)},[_vm._t("tooltip")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }